import { stateToProps } from '../smart_bps/bps/base_view'

/**
 * stateToProps с добавлением required_fields из state (для иконки обязательных полей;
 * ядро не трогаем, храним required_fields только в sigur_cs).
 */
export function stateToPropsSigur(state, projectName) {
  const projectData = state[projectName] || {}
  return {
    ...stateToProps(state, projectName),
    required_fields: projectData.required_fields,
  }
}
